<script setup lang="ts">
defineProps<{
  message: string
}>()
</script>

<template>
  <v-alert type="warning" variant="tonal" icon="inventory_2" class="archive-notice mb-4">
    <div class="archive-notice__body">
      <span class="text-high-emphasis">{{ message }}</span>
      <div v-if="$slots.action" class="archive-notice__action">
        <slot name="action" />
      </div>
    </div>
  </v-alert>
</template>

<style scoped lang="scss">
.archive-notice {
  grid-template-areas: 'prepend content append close' 'prepend content . .';
}

.archive-notice :deep(.v-alert__prepend) {
  align-self: center;
}

.archive-notice__body {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 24px;
}

.archive-notice__body > span {
  flex: 1 1 280px;
}

.archive-notice__action {
  flex: 0 1 auto;
  max-width: 100%;
}

.archive-notice__action :deep(.v-btn) {
  max-width: 100%;
  height: auto;
  min-height: 36px;
}

.archive-notice__action :deep(.v-btn__content) {
  white-space: normal;
  text-align: start;
}
</style>
